import {
  Alert,
  Checkbox,
  FormControlLabel,
  Backdrop,
  Typography,
  InputLabel,
  Container,
  Stack,
  Grid,
  Box,
  FormControl,
  TextField,
  InputAdornment,
  Divider,
  Button,
} from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Downloadpdficon from "./Downloadpdficon.png";
import pdficon from "./pdf_9496432.png";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { PDFDocument } from "pdf-lib";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useParams } from "react-router-dom";
import classes from "./ParticipanteClasses.css";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Cancel from "@mui/icons-material/Cancel";
import * as React from "react";
import logoblack from "../../../Components/logoinjupemp.png";
import dayjs from "dayjs";
import "dayjs/locale/es"; // Importa el archivo de localización para español
import CircularProgress from "@mui/material/CircularProgress";
import DialogContent from "@mui/material/DialogContent";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DialogContentText from "@mui/material/DialogContentText";
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import AvalPrecargado from "./aval1_precargado_simplificado";
import Aval2Precargado from "./aval2_precargado_simplificado";
import { useContext } from "react";
import { ContextSession } from "../../../services/ContextSession";
import { post } from "../../../services/http";
import { CalendarIcon } from "@mui/x-date-pickers/icons";
import { useNavigate } from "react-router-dom";
import LoopIcon from "@mui/icons-material/Loop";
import { useMediaQuery } from "@mui/material";

dayjs.locale("es"); // Establece el idioma local a español

async function getSolicitudInfo(accesos, ip, sid) {
  let json = { SolicitudID: sid };
  let url = "https://be.injupemp.gob.hn:8443/api/completa/";
  //let url = "http://172.20.7.10:8082/api/completa/"; //ip pruebas
  let auto = "Bearer " + accesos;

  let datas = await post(url, json, auto);
  return datas;
}

async function sendDataSolicitud(accesos, ip, json) {
  try {
    const data = new FormData();

    //data.append('data', JSON.stringify(json));
    // console.log(data);

    let url = "https://be.injupemp.gob.hn:8443/api/estado/";
    //let url = "http://172.20.7.10:8082/api/estado/"; //IP PRUEBAS
    let auto = "Bearer " + accesos;

    let datas = await post(url, json);
    return datas;
  } catch (error) {
    console.error(error);
  }
}

function SolicitudCargaSimplificada() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:820px)"); // Detectar si es una pantalla móvil

  let sessi = useContext(ContextSession);
  //const { SolicitudID } = useParams(); // Aquí obtenemos el SolicitudID desde la URL
  //const [tipoPrestamo, setTipoPrestamo] = useState('all');
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [fechaVacia, setFechaVacia] = React.useState(null);
  const [selectedDateAval2, setSelectedDateAval2] = React.useState(null);
  const [fechaVaciaAval2, setFechaVaciaAval2] = React.useState(null);
  const [filas, setFilas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialogEnviada, setOpenDialogEnviada] = useState(false);
  const [openDialogRechazada, setOpenDialogRechazada] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);

  //Archivo PDF
  const [pdfUrl, setPdfUrl] = React.useState("");
  const [pdfUrlAval1, setPdfUrlAval1] = React.useState("");
  const [pdfUrlAval2, setPdfUrlAval2] = React.useState("");
  const [pdfUrlVoucher, setPdfUrlVoucher] = React.useState("");
  const [pdfUrlVoucherAval1, setPdfUrlVoucherAval1] = React.useState("");
  const [pdfUrlVoucherAval2, setPdfUrlVoucherAval2] = React.useState("");
  const [pdfUrlAproximado, setPdfUrlAproximado] = React.useState("");
  const [pdfUrlAdeudado, setPdfUrlAdeudado] = React.useState("");

  const [openPdf, setOpenPdf] = useState(false);
  const [openPdfAval1, setOpenPdfAval1] = useState(false);
  const [openPdfAval2, setOpenPdfAval2] = useState(false);
  const [openPdfVoucher, setOpenPdfVoucher] = useState(false);
  const [openPdfVoucherAval1, setOpenPdfVoucherAval1] = useState(false);
  const [openPdfVoucherAval2, setOpenPdfVoucherAval2] = useState(false);
  const [openPdfAproximado, setOpenPdfAproximado] = useState(false);
  const [openPdfAdeudado, setOpenPdfAdeudado] = useState(false);
  const [openPdfCentral, setOpenPdfCentral] = useState(false);
  const [pdfUrlCentral, setPdfUrlCentral] = React.useState("");

  const handleCloseDialogEnviada = () => {
    setOpenDialogEnviada(false);
  };

  const handleCloseDialogRechazada = () => {
    setOpenDialogRechazada(false);
  };

  //Variables de estado para el formulario

  //Datos de la solicitud
  const [faseSolicitud, setFaseSolicitud] = useState("");
  const [estadoSolicitud, setEstadoSolicitud] = useState(null);
  const [observacion, setObservacion] = useState("");
  const [idEnviar, setIDenviar] = useState("");
  const [montoSolicitado, setMontoSolicitado] = useState("");
  const [comentarioIngresado, setComentarioIngresado] = useState("");
  const [EstadoParticipante, setEstadoParticipante] = useState("");

  //Datos del solicitante
  const [numeroSolicitud, setNumeroSolicitud] = useState("");
  const [numeroCotizante, setNumeroCotizante] = useState("");
  const [tipoPrestamo, setTipoPrestamo] = useState("");
  const [tipoHipotecario, setTipoHipotecario] = useState("");
  const [identidadSolicitante, setIdentidadSolicitante] = useState("");
  const [nombresSolicitante, setNombresSolicitante] = useState("");
  const [apellidosSolicitante, setApellidosSolicitante] = useState("");
  const [nacimientoSolicitante, setNacimientoSolicitante] = useState("");
  const [profesionSolicitante, setProfesionSolicitante] = useState("");
  const [tipoViviendaSolicitante, setTipoViviendaSolicitante] = useState("");
  const [direccionSolicitante, setDireccionSolicitante] = useState("");
  const [barrioSolicitante, setBarrioSolicitante] = useState("");
  const [avenidaSolicitante, setAvenidaSolicitante] = useState("");
  const [calleSolicitante, setCalleSolicitante] = useState("");
  const [casaSolicitante, setCasaSolicitante] = useState("");
  const [ciudadSolicitante, setCiudadSolicitante] = useState("");
  const [departamentoSolicitante, setDepartamentoSolicitante] = useState("");
  const [estadoCivilSolicitante, setEstadoCivilSolicitante] = useState("");
  const [referenciaDomicilioSolicitante, setReferenciaDomicilioSolicitante] =
    useState("");
  const [fijoSolicitante, setFijoSolicitante] = useState("");
  const [movilSolicitante, setMovilSolicitante] = useState("");
  const [correoSolicitante, setCorreoSolicitante] = useState("");

  //Informacion laboral del solicitante
  //const [Solicitante, setSolicitante] = useState("");
  const [dependenciaSolicitante, setDependenciaSolicitante] = useState("");
  const [ramoSolicitante, setRamoSolicitante] = useState("");
  const [telefonoLaboralSolicitante, setTelefonoLaboralSolicitante] =
    useState("");
  const [barrioLaboralSolicitante, setBarrioLaboralSolicitante] = useState("");
  const [avenidaLaboralSolicitante, setAvenidaLaboralSolicitante] =
    useState("");
  const [calleLaboralSolicitante, setCalleLaboralSolicitante] = useState("");
  const [casaLaboralSolicitante, setCasaLaboralSolicitante] = useState("");
  const [ciudadLaboralSolicitante, setCiudadLaboralSolicitante] = useState("");
  const [departamentoLaboralSolicitante, setDepartamentoLaboralSolicitante] =
    useState("");
  const [sueldoMensualSolicitante, setSueldoMensualSolicitante] = useState("");
  const [otrosIngresosSolicitante, setOtrosIngresosSolicitante] = useState("");
  const [sueldoNetoSolicitante, setSueldoNetoSolicitante] = useState("");
  const [puestoSolicitante, setPuestoSolicitante] = useState("");
  const [tiempoLaborarASolicitante, setTiempoLaborarASolicitante] =
    useState("");
  const [tiempoLaborarMSolicitante, setTiempoLaborarMSolicitante] =
    useState("");

  //Referencias Personales
  const [referencia1, setReferencia1] = useState("");
  const [parentescoReferencia1, setParentescoReferencia1] = useState("");
  const [direccionReferencia1, setDireccionReferencia1] = useState("");
  const [telefonoReferencia1, setTelefonoReferencia1] = useState("");
  const [referencia2, setReferencia2] = useState("");
  const [parentescoReferencia2, setParentescoReferencia2] = useState("");
  const [direccionReferencia2, setDireccionReferencia2] = useState("");
  const [telefonoReferencia2, setTelefonoReferencia2] = useState("");

  //Aval1
  const [identidadAval1, setIdentidadAval1] = useState("");
  const [nombresAval1, setNombresAval1] = useState("");
  const [apellidosAval1, setApellidosAval1] = useState("");
  const [nacimientoAval1, setNacimientoAval1] = useState("");
  const [profesionAval1, setProfesionAval1] = useState("");
  const [tipoViviendaAval1, setTipoViviendaAval1] = useState("");
  const [direccionAval1, setDireccionAval1] = useState("");
  const [barrioAval1, setBarrioAval1] = useState("");
  const [avenidaAval1, setAvenidaAval1] = useState("");
  const [calleAval1, setCalleAval1] = useState("");
  const [casaAval1, setCasaAval1] = useState("");
  const [ciudadAval1, setCiudadAval1] = useState("");
  const [departamentoAval1, setDepartamentoAval1] = useState("");
  const [estadoCivilAval1, setEstadoCivilAval1] = useState("");
  const [referenciaDomicilioAval1, setReferenciaDomicilioAval1] = useState("");
  const [fijoAval1, setFijoAval1] = useState("");
  const [movilAval1, setMovilAval1] = useState("");
  const [correoAval1, setCorreoAval1] = useState("");
  const [dependenciaAval1, setDependenciaAval1] = useState("");
  const [ramoAval1, setRamoAval1] = useState("");
  const [telefonoLaboralAval1, setTelefonoLaboralAval1] = useState("");
  const [barrioLaboralAval1, setBarrioLaboralAval1] = useState("");
  const [avenidaLaboralAval1, setAvenidaLaboralAval1] = useState("");
  const [calleLaboralAval1, setCalleLaboralAval1] = useState("");
  const [casaLaboralAval1, setCasaLaboralAval1] = useState("");
  const [ciudadLaboralAval1, setCiudadLaboralAval1] = useState("");
  const [departamentoLaboralAval1, setDepartamentoLaboralAval1] = useState("");
  const [sueldoMensualAval1, setSueldoMensualAval1] = useState("");
  const [otrosIngresosAval1, setOtrosIngresosAval1] = useState("");
  const [sueldoNetoAval1, setSueldoNetoAval1] = useState("");
  const [puestoAval1, setPuestoAval1] = useState("");
  const [tiempoLaborarAAval1, setTiempoLaborarAAval1] = useState("");
  const [tiempoLaborarMAval1, setTiempoLaborarMAval1] = useState("");

  //Aval 2
  const [identidadAval2, setIdentidadAval2] = useState("");
  const [nombresAval2, setNombresAval2] = useState("");
  const [apellidosAval2, setApellidosAval2] = useState("");
  const [nacimientoAval2, setNacimientoAval2] = useState("");
  const [profesionAval2, setProfesionAval2] = useState("");
  const [tipoViviendaAval2, setTipoViviendaAval2] = useState("");
  const [direccionAval2, setDireccionAval2] = useState("");
  const [barrioAval2, setBarrioAval2] = useState("");
  const [avenidaAval2, setAvenidaAval2] = useState("");
  const [calleAval2, setCalleAval2] = useState("");
  const [casaAval2, setCasaAval2] = useState("");
  const [ciudadAval2, setCiudadAval2] = useState("");
  const [departamentoAval2, setDepartamentoAval2] = useState("");
  const [estadoCivilAval2, setEstadoCivilAval2] = useState("");
  const [referenciaDomicilioAval2, setReferenciaDomicilioAval2] = useState("");
  const [fijoAval2, setFijoAval2] = useState("");
  const [movilAval2, setMovilAval2] = useState("");
  const [correoAval2, setCorreoAval2] = useState("");
  const [dependenciaAval2, setDependenciaAval2] = useState("");
  const [ramoAval2, setRamoAval2] = useState("");
  const [telefonoLaboralAval2, setTelefonoLaboralAval2] = useState("");
  const [barrioLaboralAval2, setBarrioLaboralAval2] = useState("");
  const [avenidaLaboralAval2, setAvenidaLaboralAval2] = useState("");
  const [calleLaboralAval2, setCalleLaboralAval2] = useState("");
  const [casaLaboralAval2, setCasaLaboralAval2] = useState("");
  const [ciudadLaboralAval2, setCiudadLaboralAval2] = useState("");
  const [departamentoLaboralAval2, setDepartamentoLaboralAval2] = useState("");
  const [sueldoMensualAval2, setSueldoMensualAval2] = useState("");
  const [otrosIngresosAval2, setOtrosIngresosAval2] = useState("");
  const [sueldoNetoAval2, setSueldoNetoAval2] = useState("");
  const [puestoAval2, setPuestoAval2] = useState("");
  const [tiempoLaborarAAval2, setTiempoLaborarAAval2] = useState("");
  const [tiempoLaborarMAval2, setTiempoLaborarMAval2] = useState("");

  //TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA
  const [tipoCuenta, setTipoCuenta] = useState("");
  const [nombreBanco, setNombreBanco] = useState("");
  const [noCuenta, setNoCuenta] = useState("");

  //Deudas A Consolidar
  //fila 1
  const [institucionNombre1, setInstitucionNombre1] = useState("");
  const [montoLempiras1, setMontoLempiras1] = useState("");
  const [montoDolares1, setMontoDolares1] = useState("");
  const [totalLempiras1, setTotalLempiras1] = useState("");
  const [consolidacionTotal1, setConsolidacionTotal1] = useState("");
  const [consolidacionParcial1, setConsolidacionParcial1] = useState("");

  //fila 2
  const [institucionNombre2, setInstitucionNombre2] = useState("");
  const [montoLempiras2, setMontoLempiras2] = useState("");
  const [montoDolares2, setMontoDolares2] = useState("");
  const [totalLempiras2, setTotalLempiras2] = useState("");
  const [consolidacionTotal2, setConsolidacionTotal2] = useState("");
  const [consolidacionParcial2, setConsolidacionParcial2] = useState("");

  //fila 3
  const [institucionNombre3, setInstitucionNombre3] = useState("");
  const [montoLempiras3, setMontoLempiras3] = useState("");
  const [montoDolares3, setMontoDolares3] = useState("");
  const [totalLempiras3, setTotalLempiras3] = useState("");
  const [consolidacionTotal3, setConsolidacionTotal3] = useState("");
  const [consolidacionParcial3, setConsolidacionParcial3] = useState("");

  //fila 4
  const [institucionNombre4, setInstitucionNombre4] = useState("");
  const [montoLempiras4, setMontoLempiras4] = useState("");
  const [montoDolares4, setMontoDolares4] = useState("");
  const [totalLempiras4, setTotalLempiras4] = useState("");
  const [consolidacionTotal4, setConsolidacionTotal4] = useState("");
  const [consolidacionParcial4, setConsolidacionParcial4] = useState("");

  //fila 5
  const [institucionNombre5, setInstitucionNombre5] = useState("");
  const [montoLempiras5, setMontoLempiras5] = useState("");
  const [montoDolares5, setMontoDolares5] = useState("");
  const [totalLempiras5, setTotalLempiras5] = useState("");
  const [consolidacionTotal5, setConsolidacionTotal5] = useState("");
  const [consolidacionParcial5, setConsolidacionParcial5] = useState("");

  //fila 6
  const [totalMontoLempiras1, setTotalMontoLempiras1] = useState("");
  const [totalMontoDolares1, setTotalMontoDolares1] = useState("");
  const [totalTotalLempiras1, setTotalTotalLempiras1] = useState("");
  const [totalConsolidacionTotal1, setTotalConsolidacionTotal1] = useState("");
  const [totalConsolidacionParcial1, setTotalConsolidacionParcial1] =
    useState("");

  //fila 7
  const [totalMontoLempiras2, setTotalMontoLempiras2] = useState("");
  const [totalMontoDolares2, setTotalMontoDolares2] = useState("");
  const [totalTotalLempiras2, setTotalTotalLempiras2] = useState("");
  const [totalConsolidacionTotal2, setTotalConsolidacionTotal2] = useState("");
  const [totalConsolidacionParcial2, setTotalConsolidacionParcial2] =
    useState("");

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [notaCorreccion, setNotaCorreccion] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--;
    }
    return `${edad} años`;
  };

  // Determinamos las opciones de checkbox según el tipo de préstamo
  const getCheckboxOptions = () => {
    if (tipoPrestamo === "Sin Aval" || tipoPrestamo === "Refinanciamiento") {
      return [
        "COPIA DE LA IDENTIDAD DEL SOLICITANTE",
        "VOUCHERS DE PAGO DEL SOLICITANTE",
      ];
    }

    if (tipoPrestamo === "Hipotecario") {
      return [
        "COPIA DE LA IDENTIDAD DEL SOLICITANTE",
        "VOUCHERS DE PAGO DEL SOLICITANTE",
        "AUTORIZACIÓN DE REFERENCIAS EN LA CENTRAL DE INFORMACIÓN CREDITICIA",
      ];
    }

    if (tipoPrestamo === "Con Aval") {
      const options = [
        "COPIA DE LA IDENTIDAD DEL SOLICITANTE",
        "VOUCHERS DE PAGO DEL SOLICITANTE",
        "COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 1",
        "VOUCHER DE PAGO EN FORMATO PDF DEL AVAL 1",
      ];

      // Evaluamos si mostrar opciones de Aval 2
      if (
        pdfUrlVoucherAval2 &&
        pdfUrlVoucherAval2.trim() !== "" &&
        pdfUrlAval2 &&
        pdfUrlAval2.trim() !== ""
      ) {
        options.push(
          "COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 2",
          "VOUCHER DE PAGO EN FORMATO PDF DEL AVAL 2",
        );
      }

      return options;
    }

    if (tipoPrestamo === "Consolidacion de Deuda") {
      const options = [
        "COPIA DE LA IDENTIDAD DEL SOLICITANTE",
        "VOUCHERS DE PAGO DEL SOLICITANTE",
        "ESTADOS DE CUENTA DE LO ADEUDADO EN FORMATO PDF",
        "COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 1",
        "VOUCHER DE PAGO EN FORMATO PDF DEL AVAL 1",
      ];

      // Evaluamos si mostrar opciones de Aval 2
      if (
        pdfUrlVoucherAval2 &&
        pdfUrlVoucherAval2.trim() !== "" &&
        pdfUrlAval2 &&
        pdfUrlAval2.trim() !== ""
      ) {
        options.push(
          "COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 2",
          "VOUCHER DE PAGO EN FORMATO PDF DEL AVAL 2",
        );
      }

      return options;
    }

    if (tipoPrestamo === "Alivio de Deuda") {
      return [
        "COPIA DE LA IDENTIDAD DEL SOLICITANTE",
        "VOUCHERS DE PAGO DEL SOLICITANTE",
        "CÁLCULO APROXIMADO DE PRESTACIONES LABORALES DEL SOLICITANTE EN FORMATO PDF",
        "ESTADOS DE CUENTA DE LO ADEUDADO EN FORMATO PDF",
        "COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 1",
        "VOUCHER DE PAGO EN FORMATO PDF DEL AVAL 1",
      ];
    }

    return [];
  };

  // Maneja el cambio de selección en los Checkboxes
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedOptions((prevSelected) => {
      if (checked) {
        return [...prevSelected, value];
      } else {
        return prevSelected.filter((option) => option !== value);
      }
    });
  };

  // Maneja el cambio en el campo de la Nota de Corrección
  const handleNotaChange = (event) => {
    setNotaCorreccion(event.target.value);
  };

  // Maneja el envío de la corrección
  const handleEnviarCorreccion = () => {
    if (!notaCorreccion.trim()) {
      setErrorMessage("La nota de corrección no puede estar vacía.");
      return;
    }

    if (selectedOptions.length === 0) {
      setErrorMessage("Debe seleccionar al menos un documento a corregir.");
      return;
    }

    // Si todo está bien, enviar la corrección
    setErrorMessage("");
    // Aquí puedes llamar a la función para enviar la corrección, por ejemplo:
    // aprobarSolicitud();
    console.log("Corrección enviada:", { notaCorreccion, selectedOptions });

    // Limpiar los valores del formulario después de enviar
    setNotaCorreccion("");
    setSelectedOptions([]);
  };

  const aprobarSolicitud = () => {
    const jsonOutput = {
      SolicitudID: idEnviar, //numeroSolicitud,
      observacion: document.getElementById("notaAprobacion").value,
      aprobado: 1,
      fecharevisado: new Date().toISOString(), //.split('T')[0]
    };

    let token = sessi.sessionData.token;

    sendDataSolicitud(token, sessi.ip, jsonOutput);
    setOpenDialogEnviada(true);
    handleClose();
    navigate("/PortalDelParticipante/Solicitudes");
  };

  const aprobarSolicitudSujeto = () => {
    const jsonOutput = {
      SolicitudID: idEnviar, //numeroSolicitud,
      observacion: document.getElementById("notaAprobacionSujeto").value,
      aprobado: 2,
      fecharevisado: new Date().toISOString(), //.split('T')[0]
    };

    let token = sessi.sessionData.token;

    sendDataSolicitud(token, sessi.ip, jsonOutput);
    setOpenDialogEnviada(true);
    handleCloseSujeto();
    navigate("/PortalDelParticipante/Solicitudes");
  };

  const rechazarSolicitud = () => {
    const jsonOutput = {
      SolicitudID: idEnviar, //numeroSolicitud,
      observacion: document.getElementById("notaRechazo").value,
      aprobado: 3,
      fecharevisado: new Date().toISOString(), //.split('T')[0]
    };

    let token = sessi.sessionData.token;

    sendDataSolicitud(token, sessi.ip, jsonOutput);
    setOpenDialogRechazada(true);
    handleCloseRechazar();
    navigate("/PortalDelParticipante/Solicitudes");
  };

  const handleButtonIdentidad = async () => {
    if (filas && filas.imagenes && filas.imagenes.SolDNI) {
      const base64Images = filas.imagenes.SolDNI;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
      setOpenPdf(true);
    }
  };

  const handleButtonCentral = async () => {
    if (filas && filas.imagenes && filas.imagenes.CentralRiesgos) {
      const base64Images = filas.imagenes.CentralRiesgos;

      if (isMobile) {
        // Mostrar imágenes en móvil
        setOpenPdfCentral(true);
        setPdfUrlCentral(base64Images); // Guardar las imágenes en base64
      } else {
        // Crear PDF
        const pdfDoc = await PDFDocument.create();
        for (const base64Image of base64Images) {
          const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
            c.charCodeAt(0),
          );
          const image = await pdfDoc.embedPng(imageBytes);
          const page = pdfDoc.addPage([image.width, image.height]);
          page.drawImage(image, {
            x: 0,
            y: 0,
            width: image.width,
            height: image.height,
          });
        }

        const pdfBytes = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrlCentral(pdfUrl);
        //console.log("EL URL DEL PDF ES:", pdfUrl);
        setOpenPdfCentral(true);
      }
    }
  };

  const handleCloseCentral = () => {
    setOpenPdfCentral(false);
    URL.revokeObjectURL(pdfUrlCentral);
    setPdfUrlCentral("");
  };

  const handleCloseIdentidad = () => {
    setOpenPdf(false);
    URL.revokeObjectURL(pdfUrl);
    setPdfUrl("");
  };

  const handleButtonAval1 = async () => {
    if (filas && filas.imagenes && filas.imagenes.Aval1DNI) {
      const base64Images = filas.imagenes.Aval1DNI;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrlAval1(pdfUrl);
      setOpenPdfAval1(true);
    }
  };

  const handleCloseAval1 = () => {
    setOpenPdfAval1(false);
    URL.revokeObjectURL(pdfUrlAval1);
    setPdfUrlAval1("");
  };

  const handleButtonAval2 = async () => {
    if (filas && filas.imagenes && filas.imagenes.Aval2DNI) {
      const base64Images = filas.imagenes.Aval2DNI;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrlAval2(pdfUrl);
      setOpenPdfAval2(true);
    }
  };

  const handleCloseAval2 = () => {
    setOpenPdfAval2(false);
    URL.revokeObjectURL(pdfUrlAval2);
    setPdfUrlAval2("");
  };

  const handleButtonVoucher = async () => {
    if (filas && filas.imagenes && filas.imagenes.Voucher) {
      const base64Images = filas.imagenes.Voucher;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrlVoucher(pdfUrl);
      setOpenPdfVoucher(true);
    }
  };

  const handleCloseVoucher = () => {
    setOpenPdfVoucher(false);
    URL.revokeObjectURL(pdfUrlVoucher);
    setPdfUrlVoucher("");
  };

  const handleButtonVoucherAval1 = async () => {
    if (filas && filas.imagenes && filas.imagenes.Aval1Voucher) {
      const base64Images = filas.imagenes.Aval1Voucher;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrlVoucherAval1(pdfUrl);
      setOpenPdfVoucherAval1(true);
    }
  };

  const handleCloseVoucherAval1 = () => {
    setOpenPdfVoucherAval1(false);
    URL.revokeObjectURL(pdfUrlVoucherAval1);
    setPdfUrlVoucherAval1("");
  };

  const handleButtonVoucherAval2 = async () => {
    if (filas && filas.imagenes && filas.imagenes.Aval2Voucher) {
      const base64Images = filas.imagenes.Aval2Voucher;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrlVoucherAval2(pdfUrl);
      setOpenPdfVoucherAval2(true);
    }
  };

  const handleCloseVoucherAval2 = () => {
    setOpenPdfVoucherAval2(false);
    URL.revokeObjectURL(pdfUrlVoucherAval2);
    setPdfUrlVoucherAval2("");
  };

  const handleButtonAproximado = async () => {
    if (filas && filas.imagenes && filas.imagenes.PrestacionesAproximado) {
      const base64Images = filas.imagenes.PrestacionesAproximado;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrlAproximado(pdfUrl);
      setOpenPdfAproximado(true);
    }
  };

  const handleButtonAdeudado = async () => {
    if (filas && filas.imagenes && filas.imagenes.EstadoDeudas) {
      const base64Images = filas.imagenes.EstadoDeudas;
      const pdfDoc = await PDFDocument.create();

      for (const base64Image of base64Images) {
        const imageBytes = Uint8Array.from(atob(base64Image), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrlAdeudado(pdfUrl);
      setOpenPdfAdeudado(true);
    }
  };

  const handleCloseAproximado = () => {
    setOpenPdfAproximado(false);
    URL.revokeObjectURL(pdfUrlAproximado);
    setPdfUrlAproximado("");
  };

  const handleCloseAdeudado = () => {
    setOpenPdfAdeudado(false);
    URL.revokeObjectURL(pdfUrlAdeudado);
    setPdfUrlAdeudado("");
  };

  React.useEffect(() => {
    const container = document.getElementById("my-container");
    container.style.zoom = "80%";

    async function fetchData() {
      let token = sessi.sessionData.token;
      let sid = sessi.getVariable("SolicitudPrestamo");
      const data = await getSolicitudInfo(token, sessi.ip, sid);
      //   console.log(`El SolicitudID Es: ${sid}`);
      setFilas(data);
      setLoading(false);
      // console.log("FILAS ", data);

      //Asignar valores a los TextField

      //Datos Del
      const response = await getSolicitudInfo(
        sessi.sessionData.token,
        sessi.ip,
        sessi.getVariable("SolicitudPrestamo"),
      );
      //   console.log("resultado de la SOLICITUD es: !!", response.Solicitud, response);
      if (response.Solicitud && response.Solicitud[0]) {
        response.Solicitud[0].NumeroSolicitud !== undefined &&
          setNumeroSolicitud(response.Solicitud[0].NumeroSolicitud);
        response.Solicitud[0].NumeroCotizante !== undefined &&
          setNumeroCotizante(response.Solicitud[0].NumeroCotizante);
        response.Solicitud[0].TipoPrestamo !== undefined &&
          setTipoPrestamo(response.Solicitud[0].TipoPrestamo);
        response.Solicitud[0].TipoHipotecario !== undefined &&
          setTipoHipotecario(response.Solicitud[0].TipoHipotecario);
        response.Solicitud[0].MontoSolicitado !== undefined &&
          setMontoSolicitado(response.Solicitud[0].MontoSolicitado);
        response.Solicitud[0].EstadoParticipante !== undefined &&
          setEstadoParticipante(response.Solicitud[0].EstadoParticipante);
        response.Solicitud[0].DetalleParticipante !== undefined &&
          setComentarioIngresado(response.Solicitud[0].DetalleParticipante);
      }

      if (response.DatosSolicitante && response.DatosSolicitante[0]) {
        response.DatosSolicitante[0].NumeroIdentidad !== undefined &&
          setIdentidadSolicitante(response.DatosSolicitante[0].NumeroIdentidad);
        response.DatosSolicitante[0].Nombres !== undefined &&
          setNombresSolicitante(response.DatosSolicitante[0].Nombres);
        response.DatosSolicitante[0].Apellidos !== undefined &&
          setApellidosSolicitante(response.DatosSolicitante[0].Apellidos);
        response.DatosSolicitante[0].FechaNacimiento !== undefined &&
          setNacimientoSolicitante(
            response.DatosSolicitante[0].FechaNacimiento,
          );
        response.DatosSolicitante[0].Profesion !== undefined &&
          setProfesionSolicitante(response.DatosSolicitante[0].Profesion);
        response.DatosSolicitante[0].TipoVivienda !== undefined &&
          setTipoViviendaSolicitante(response.DatosSolicitante[0].TipoVivienda);
        response.DatosSolicitante[0].BarrioCol !== undefined &&
          setBarrioSolicitante(response.DatosSolicitante[0].BarrioCol);
        response.DatosSolicitante[0].Ave !== undefined &&
          setAvenidaSolicitante(response.DatosSolicitante[0].Ave);
        response.DatosSolicitante[0].Calle !== undefined &&
          setCalleSolicitante(response.DatosSolicitante[0].Calle);
        response.DatosSolicitante[0].CasaNo !== undefined &&
          setCasaSolicitante(response.DatosSolicitante[0].CasaNo);
        response.DatosSolicitante[0].Ciudad !== undefined &&
          setCiudadSolicitante(response.DatosSolicitante[0].Ciudad);
        response.DatosSolicitante[0].Departamento !== undefined &&
          setDepartamentoSolicitante(response.DatosSolicitante[0].Departamento);
        response.DatosSolicitante[0].EstadoCivil !== undefined &&
          setEstadoCivilSolicitante(response.DatosSolicitante[0].EstadoCivil);
        response.DatosSolicitante[0].ReferenciaDomicilio !== undefined &&
          setReferenciaDomicilioSolicitante(
            response.DatosSolicitante[0].ReferenciaDomicilio,
          );
        response.DatosSolicitante[0].TelefonoFijo !== undefined &&
          setFijoSolicitante(response.DatosSolicitante[0].TelefonoFijo);
        response.DatosSolicitante[0].TelefonoMovil !== undefined &&
          setMovilSolicitante(response.DatosSolicitante[0].TelefonoMovil);
        response.DatosSolicitante[0].CorreoElectronico !== undefined &&
          setCorreoSolicitante(response.DatosSolicitante[0].CorreoElectronico);
      }

      //datos de la solicitud
      if (response.Solicitud && response.Solicitud[0]) {
        setEstadoSolicitud(response.Solicitud[0].aprobado);
        setFaseSolicitud(response.Solicitud[0].Estado ?? "");
        setObservacion(response.Solicitud[0].observacion ?? "");
        setIDenviar(response.Solicitud[0].SolicitudID ?? "");
      }

      //Informacion laboral del solicitante
      if (response.InformacionLaboral && response.InformacionLaboral[0]) {
        //setSolicitante(response.InformacionLaboral[0].);
        response.InformacionLaboral[0].DependenciaTrabajo !== undefined &&
          setDependenciaSolicitante(
            response.InformacionLaboral[0].DependenciaTrabajo,
          );
        response.InformacionLaboral[0].Ramo !== undefined &&
          setRamoSolicitante(response.InformacionLaboral[0].Ramo);
        response.InformacionLaboral[0].Telefono !== undefined &&
          setTelefonoLaboralSolicitante(
            response.InformacionLaboral[0].Telefono,
          );
        response.InformacionLaboral[0].BarrioCol !== undefined &&
          setBarrioLaboralSolicitante(response.InformacionLaboral[0].BarrioCol);
        response.InformacionLaboral[0].Ave !== undefined &&
          setAvenidaLaboralSolicitante(response.InformacionLaboral[0].Ave);
        response.InformacionLaboral[0].Calle !== undefined &&
          setCalleLaboralSolicitante(response.InformacionLaboral[0].Calle);
        response.InformacionLaboral[0].CasaNo !== undefined &&
          setCasaLaboralSolicitante(response.InformacionLaboral[0].CasaNo);
        response.InformacionLaboral[0].Ciudad !== undefined &&
          setCiudadLaboralSolicitante(response.InformacionLaboral[0].Ciudad);
        response.InformacionLaboral[0].Departamento !== undefined &&
          setDepartamentoLaboralSolicitante(
            response.InformacionLaboral[0].Departamento,
          );
        response.InformacionLaboral[0].SueldoMensual !== undefined &&
          setSueldoMensualSolicitante(
            response.InformacionLaboral[0].SueldoMensual,
          );
        response.InformacionLaboral[0].OtrosIngresos !== undefined &&
          setOtrosIngresosSolicitante(
            response.InformacionLaboral[0].OtrosIngresos,
          );
        response.InformacionLaboral[0].SueldoNeto !== undefined &&
          setSueldoNetoSolicitante(response.InformacionLaboral[0].SueldoNeto);
        response.InformacionLaboral[0].Puesto !== undefined &&
          setPuestoSolicitante(response.InformacionLaboral[0].Puesto);
        response.InformacionLaboral[0].TiempoLaborarAnios !== undefined &&
          setTiempoLaborarASolicitante(
            response.InformacionLaboral[0].TiempoLaborarAnios,
          );
        response.InformacionLaboral[0].TiempoLaborarMeses !== undefined &&
          setTiempoLaborarMSolicitante(
            response.InformacionLaboral[0].TiempoLaborarMeses,
          );
      }

      //Referencias Personales
      if (response.ReferenciasPersonales[0]) {
        response.ReferenciasPersonales[0].Nombre !== undefined &&
          setReferencia1(response.ReferenciasPersonales[0].Nombre);
        response.ReferenciasPersonales[0].Parentesco !== undefined &&
          setParentescoReferencia1(
            response.ReferenciasPersonales[0].Parentesco,
          );
        response.ReferenciasPersonales[0].Direccion !== undefined &&
          setDireccionReferencia1(response.ReferenciasPersonales[0].Direccion);
        response.ReferenciasPersonales[0].Telefono !== undefined &&
          setTelefonoReferencia1(response.ReferenciasPersonales[0].Telefono);
      }
      if (response.ReferenciasPersonales[1]) {
        response.ReferenciasPersonales[1].Nombre !== undefined &&
          setReferencia2(response.ReferenciasPersonales[1].Nombre);
        response.ReferenciasPersonales[1].Parentesco !== undefined &&
          setParentescoReferencia2(
            response.ReferenciasPersonales[1].Parentesco,
          );
        response.ReferenciasPersonales[1].Direccion !== undefined &&
          setDireccionReferencia2(response.ReferenciasPersonales[1].Direccion);
        response.ReferenciasPersonales[1].Telefono !== undefined &&
          setTelefonoReferencia2(response.ReferenciasPersonales[1].Telefono);
      }

      if (
        response.Solicitud[0].TipoPrestamo === "Con Aval" ||
        response.Solicitud[0].TipoPrestamo === "Consolidacion de Deuda"
      ) {
        //Aval1
        setIdentidadAval1(response.DatosAval[0].NumeroIdentidad);
        setNombresAval1(response.DatosAval[0].Nombres);
        setApellidosAval1(response.DatosAval[0].Apellidos);
        setNacimientoAval1(response.DatosAval[0].FechaNacimiento ?? "");
        setProfesionAval1(response.DatosAval[0].Profesion ?? "");
        setTipoViviendaAval1(response.DatosAval[0].TipoVivienda ?? "");
        setBarrioAval1(response.DatosAval[0].BarrioCol ?? "");
        setAvenidaAval1(response.DatosAval[0].Ave ?? "");
        setCalleAval1(response.DatosAval[0].Calle ?? "");
        setCasaAval1(response.DatosAval[0].CasaNo ?? "");
        setCiudadAval1(response.DatosAval[0].Ciudad ?? "");
        setDepartamentoAval1(response.DatosAval[0].Departamento ?? "");
        setEstadoCivilAval1(response.DatosAval[0].EstadoCivil ?? "");
        setReferenciaDomicilioAval1(
          response.DatosAval[0].ReferenciaDomicilio ?? "",
        );
        setFijoAval1(response.DatosAval[0].TelefonoFijo ?? "");
        setMovilAval1(response.DatosAval[0].TelefonoMovil ?? "");
        setCorreoAval1(response.DatosAval[0].CorreoElectronico ?? "");
        setDependenciaAval1(
          response.InformacionLaboralAval[0].DependenciaTrabajo ?? "",
        );
        setRamoAval1(response.InformacionLaboralAval[0].Ramo ?? "");
        setTelefonoLaboralAval1(
          response.InformacionLaboralAval[0].Telefono ?? "",
        );
        setBarrioLaboralAval1(
          response.InformacionLaboralAval[0].BarrioCol ?? "",
        );
        setAvenidaLaboralAval1(response.InformacionLaboralAval[0].Ave ?? "");
        setCalleLaboralAval1(response.InformacionLaboralAval[0].Calle ?? "");
        setCasaLaboralAval1(response.InformacionLaboralAval[0].CasaNo ?? "");
        setCiudadLaboralAval1(response.InformacionLaboralAval[0].Ciudad ?? "");
        setDepartamentoLaboralAval1(
          response.InformacionLaboralAval[0].Departamento ?? "",
        );
        setSueldoMensualAval1(
          response.InformacionLaboralAval[0].SueldoMensual ?? "",
        );
        setOtrosIngresosAval1(
          response.InformacionLaboralAval[0].OtrosIngresos ?? "",
        );
        setSueldoNetoAval1(response.InformacionLaboralAval[0].SueldoNeto ?? "");
        setPuestoAval1(response.InformacionLaboralAval[0].Puesto ?? "");
        setTiempoLaborarAAval1(
          response.InformacionLaboralAval[0].TiempoLaborarAnios ?? "",
        );
        setTiempoLaborarMAval1(
          response.InformacionLaboralAval[0].TiempoLaborarMeses ?? "",
        );

        if (response.DatosAval && response.DatosAval[1]) {
          //Aval 2
          setIdentidadAval2(response.DatosAval[1].NumeroIdentidad ?? "");
          setNombresAval2(response.DatosAval[1].Nombres ?? "");
          setApellidosAval2(response.DatosAval[1].Apellidos ?? "");
          setNacimientoAval2(response.DatosAval[1].FechaNacimiento ?? "");
          setProfesionAval2(response.DatosAval[1].Profesion ?? "");
          setTipoViviendaAval2(response.DatosAval[1].TipoVivienda ?? "");
          setBarrioAval2(response.DatosAval[1].BarrioCol ?? "");
          setAvenidaAval2(response.DatosAval[1].Ave ?? "");
          setCalleAval2(response.DatosAval[1].Calle ?? "");
          setCasaAval2(response.DatosAval[1].CasaNo ?? "");
          setCiudadAval2(response.DatosAval[1].Ciudad ?? "");
          setDepartamentoAval2(response.DatosAval[1].Departamento ?? "");
          setEstadoCivilAval2(response.DatosAval[1].EstadoCivil ?? "");
          setReferenciaDomicilioAval2(
            response.DatosAval[1].ReferenciaDomicilio ?? "",
          );
          setFijoAval2(response.DatosAval[1].TelefonoFijo ?? "");
          setMovilAval2(response.DatosAval[1].TelefonoMovil ?? "");
          setCorreoAval2(response.DatosAval[1].CorreoElectronico ?? "");
          setDependenciaAval2(
            response.InformacionLaboralAval[1].DependenciaTrabajo ?? "",
          );
          setRamoAval2(response.InformacionLaboralAval[1].Ramo ?? "");
          setTelefonoLaboralAval2(
            response.InformacionLaboralAval[1].Telefono ?? "",
          );
          setBarrioLaboralAval2(
            response.InformacionLaboralAval[1].BarrioCol ?? "",
          );
          setAvenidaLaboralAval2(response.InformacionLaboralAval[1].Ave ?? "");
          setCalleLaboralAval2(response.InformacionLaboralAval[1].Calle ?? "");
          setCasaLaboralAval2(response.InformacionLaboralAval[1].CasaNo ?? "");
          setCiudadLaboralAval2(
            response.InformacionLaboralAval[1].Ciudad ?? "",
          );
          setDepartamentoLaboralAval2(
            response.InformacionLaboralAval[1].Departamento ?? "",
          );
          setSueldoMensualAval2(
            response.InformacionLaboralAval[1].SueldoMensual ?? "",
          );
          setOtrosIngresosAval2(
            response.InformacionLaboralAval[1].OtrosIngresos ?? "",
          );
          setSueldoNetoAval2(
            response.InformacionLaboralAval[1].SueldoNeto ?? "",
          );
          setPuestoAval2(response.InformacionLaboralAval[1].Puesto ?? "");
          setTiempoLaborarAAval2(
            response.InformacionLaboralAval[1].TiempoLaborarAnios ?? "",
          );
          setTiempoLaborarMAval2(
            response.InformacionLaboralAval[1].TiempoLaborarMeses ?? "",
          );
        }
      }

      //TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA
      if (response.TransferenciaPago && response.TransferenciaPago[0]) {
        response.TransferenciaPago[0].TipoCuenta !== undefined &&
          setTipoCuenta(response.TransferenciaPago[0].TipoCuenta);
        response.TransferenciaPago[0].Banco !== undefined &&
          setNombreBanco(response.TransferenciaPago[0].Banco);
        response.TransferenciaPago[0].NoCuenta !== undefined &&
          setNoCuenta(response.TransferenciaPago[0].NoCuenta);
      }

      //Deudas A Consolidar
      //fila 1
      if (response.DeudasConsolidar && response.DeudasConsolidar[0]) {
        response.DeudasConsolidar[0].InstitucionFinanciera !== undefined &&
          setInstitucionNombre1(
            response.DeudasConsolidar[0].InstitucionFinanciera,
          );
        response.DeudasConsolidar[0].MontoLempiras !== undefined &&
          setMontoLempiras1(response.DeudasConsolidar[0].MontoLempiras);
        response.DeudasConsolidar[0].MontoDolares !== undefined &&
          setMontoDolares1(response.DeudasConsolidar[0].MontoDolares);
        response.DeudasConsolidar[0].TotalLempiras !== undefined &&
          setTotalLempiras1(response.DeudasConsolidar[0].TotalLempiras);
        response.DeudasConsolidar[0].ConsolidacionTotal !== undefined &&
          setConsolidacionTotal1(
            response.DeudasConsolidar[0].ConsolidacionTotal,
          );
        response.DeudasConsolidar[0].ConsolidacionParcial !== undefined &&
          setConsolidacionParcial1(
            response.DeudasConsolidar[0].ConsolidacionParcial,
          );
      }
      //fila 2
      if (response.DeudasConsolidar && response.DeudasConsolidar[1]) {
        setInstitucionNombre2(
          response.DeudasConsolidar[1].InstitucionFinanciera ?? "",
        );
        setMontoLempiras2(response.DeudasConsolidar[1].MontoLempiras ?? "");
        setMontoDolares2(response.DeudasConsolidar[1].MontoDolares ?? "");
        setTotalLempiras2(response.DeudasConsolidar[1].TotalLempiras ?? "");
        setConsolidacionTotal2(
          response.DeudasConsolidar[1].ConsolidacionTotal ?? "",
        );
        setConsolidacionParcial2(
          response.DeudasConsolidar[1].ConsolidacionParcial ?? "",
        );
      }

      //fila 3
      if (response.DeudasConsolidar && response.DeudasConsolidar[2]) {
        setInstitucionNombre3(
          response.DeudasConsolidar[2].InstitucionFinanciera ?? "",
        );
        setMontoLempiras3(response.DeudasConsolidar[2].MontoLempiras ?? "");
        setMontoDolares3(response.DeudasConsolidar[2].MontoDolares ?? "");
        setTotalLempiras3(response.DeudasConsolidar[2].TotalLempiras ?? "");
        setConsolidacionTotal3(
          response.DeudasConsolidar[2].ConsolidacionTotal ?? "",
        );
        setConsolidacionParcial3(
          response.DeudasConsolidar[2].ConsolidacionParcial ?? "",
        );
      }

      //fila 4
      if (response.DeudasConsolidar && response.DeudasConsolidar[3]) {
        setInstitucionNombre4(
          response.DeudasConsolidar[3].InstitucionFinanciera ?? "",
        );
        setMontoLempiras4(response.DeudasConsolidar[3].MontoLempiras ?? "");
        setMontoDolares4(response.DeudasConsolidar[3].MontoDolares ?? "");
        setTotalLempiras4(response.DeudasConsolidar[3].TotalLempiras ?? "");
        setConsolidacionTotal4(
          response.DeudasConsolidar[3].ConsolidacionTotal ?? "",
        );
        setConsolidacionParcial4(
          response.DeudasConsolidar[3].ConsolidacionParcial ?? "",
        );
      }

      //fila 5
      if (response.DeudasConsolidar && response.DeudasConsolidar[4]) {
        setInstitucionNombre5(
          response.DeudasConsolidar[4].InstitucionFinanciera ?? "",
        );
        setMontoLempiras5(response.DeudasConsolidar[4].MontoLempiras ?? "");
        setMontoDolares5(response.DeudasConsolidar[4].MontoDolares ?? "");
        setTotalLempiras5(response.DeudasConsolidar[4].TotalLempiras ?? "");
        setConsolidacionTotal5(
          response.DeudasConsolidar[4].ConsolidacionTotal ?? "",
        );
        setConsolidacionParcial5(
          response.DeudasConsolidar[4].ConsolidacionParcial ?? "",
        );
      }

      /*if (response.TotalesPrestamo[0]) {
                //fila 6 totales
                setTotalMontoLempiras1(response.TotalesPrestamo[0].TotalMontoLempiras ?? '');
                setTotalMontoDolares1(response.TotalesPrestamo[0].TotalMontoDolares ?? '');
                setTotalTotalLempiras1(response.TotalesPrestamo[0].TotalTotalLempiras ?? '');
                setTotalConsolidacionTotal1(response.TotalesPrestamo[0].TotalConsolidacionTotal ?? '');
                setTotalConsolidacionParcial1(response.TotalesPrestamo[0].TotalConsolidacionParcial ?? '');
            }*/

      /*if (response.TotalesMontoAFavor[0]) {
                //fila 7 total monto a favor
                setTotalMontoLempiras2(response.TotalesMontoAFavor[0].TotalMontoLempiras ?? '');
                setTotalMontoDolares2(response.TotalesMontoAFavor[0].TotalMontoDolares ?? '');
                setTotalTotalLempiras2(response.TotalesMontoAFavor[0].TotalTotalLempiras ?? '');
                setTotalConsolidacionTotal2(response.TotalesMontoAFavor[0].TotalConsolidacionTotal ?? '');
                setTotalConsolidacionParcial2(response.TotalesMontoAFavor[0].TotalConsolidacionParcial ?? '');
            }*/
    }
    fetchData();
  }, []);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#19438C",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [openCorregirDocumentos, setOpenCorregirDocumentos] =
    React.useState(false);
  const [openSujeto, setOpenSujeto] = React.useState(false);
  const [openRechazar, setOpenRechazar] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseCorregirDocumentos = () => {
    setOpenCorregirDocumentos(false);
    setNotaCorreccion("");
    setSelectedOptions([]);
    setErrorMessage("");
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleOpenCorregirDocumentos = () => {
    setOpenCorregirDocumentos(true);
  };

  const handleCloseSujeto = () => {
    setOpenSujeto(false);
  };

  const handleOpenSujeto = () => {
    setOpenSujeto(true);
  };

  const handleCloseRechazar = () => {
    setOpenRechazar(false);
  };

  const handleOpenRechazar = () => {
    setOpenRechazar(true);
  };

  return (
    <>
      <div id="my-container">
        <Container style={{ marginTop: 100 }}>
          <Stack direction="row">
            <Grid spacing={2} container>
              <Grid item xs={10} md={2.2}>
                <img style={{ width: 200, height: "auto" }} src={logoblack} />
              </Grid>
              <Grid style={{ textAlign: "center" }} item xs={4} md={5.8}>
                <h1>SOLICITUD DE PREANÁLISIS DE PRÉSTAMO</h1>
              </Grid>
              <Grid item xs={4} md={4}>
                <Stack>
                  <Box>
                    <label style={{ marginRight: 10 }}>No. Solicitud: </label>
                    {/*<TextField id="NoSolicitud" variant="standard" InputProps={{ readOnly: true }} />*/}
                    <TextField
                      id="NoSolicitud"
                      variant="standard"
                      value={numeroSolicitud}
                      InputProps={{ readOnly: true }}
                    />
                  </Box>
                  <Box>
                    <label style={{ marginRight: 10, visibility: "hidden" }}>
                      No. Cotizante:
                    </label>
                    <TextField
                      id="NoCotizante"
                      variant="standard"
                      value={numeroCotizante}
                      InputProps={{ readOnly: true }}
                      style={{ visibility: "hidden" }}
                    />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Stack>

          <Stack direction="row" alignItems="center">
            <label style={{ marginRight: 10 }}>
              <strong>TIPO DE PRÉSTAMO:</strong>
            </label>
            <label>{tipoPrestamo}</label>
          </Stack>
          <Divider />
          {tipoPrestamo === "Hipotecario" && (
            <Stack
              direction="row"
              alignItems="center"
              marginTop={5}
              justifyContent={"flex-start"}
            >
              <label style={{ marginRight: 10 }}>
                <strong>TIPO HIPOTECARIO:</strong>
              </label>
              <label>{tipoHipotecario}</label>
            </Stack>
          )}
          <Grid item marginTop={3}>
            {estadoSolicitud === 1 ? (
              <>
                <Typography variant="h6" style={{ color: "green" }}>
                  <CheckCircle fontSize="small" /> Solicitud Pre Aprobada
                </Typography>
                <InputLabel>
                  <b>Observación:</b> {observacion}
                </InputLabel>
              </>
            ) : estadoSolicitud === 2 ? (
              <>
                <Typography variant="h6" style={{ color: "orange" }}>
                  <CheckCircle fontSize="small" /> Solicitud Pre Aprobada Sujeta
                  A Cambios
                </Typography>
                <InputLabel>
                  <b>Observación:</b> {observacion}
                </InputLabel>
              </>
            ) : estadoSolicitud === 3 ? (
              <>
                <Typography variant="h6" style={{ color: "red" }}>
                  <Cancel fontSize="small" /> Rechazado
                </Typography>
                <InputLabel>
                  <b>Observación:</b> {observacion}
                </InputLabel>
              </>
            ) : (
              <></>
            )}
          </Grid>

          {tipoPrestamo !== "Hipotecario" && (
            <Stack direction="row" alignItems="center">
              <h3 style={{ marginRight: 10 }}>MONTO SOLICITADO:</h3>
              <FormControl sx={{ m: 1, width: 200 }}>
                <TextField
                  id="montosolicitado"
                  variant="standard"
                  value={montoSolicitado}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">L.</InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              </FormControl>
            </Stack>
          )}

          <Stack
            direction="column" // Siempre en columna
            alignItems="flex-start" // Alinea los elementos al inicio del contenedor
            spacing={2} // Espaciado entre los elementos
            marginTop={3}
          >
            <h3 style={{ textAlign: "center" }}>
              Comentarios sobre la solicitud:
            </h3>
            <FormControl sx={{ m: 1, width: "100%" }}>
              <TextField
                label="Comentario Ingresado"
                id="ComentarioParticipante"
                multiline
                rows={4}
                variant="outlined"
                value={comentarioIngresado || "No ingresó comentarios"}
              />
            </FormControl>
          </Stack>

          <Box>
            <Stack direction="row">
              <h3>I. DATOS DEL SOLICITANTE</h3>
            </Stack>

            <Stack direction="row">
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, width: 200 }}>
                  <TextField
                    id="solicitanteIdentidad"
                    label="Numero de Identidad"
                    value={identidadSolicitante}
                    variant="standard"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: 400 }}>
                  <TextField
                    id="solicitanteNombres"
                    label="Nombres"
                    value={nombresSolicitante}
                    variant="standard"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: 400 }}>
                  <TextField
                    id="solicitanteApellidos"
                    value={apellidosSolicitante}
                    label="Apellidos"
                    variant="standard"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: 200 }}>
                  <TextField
                    id="solicitanteNacimiento"
                    value={nacimientoSolicitante}
                    label="Fecha De Nacimiento"
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <CalendarIcon />
                        </InputAdornment>
                      ),
                      readOnly: true,
                    }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: 200 }}>
                  <TextField
                    id="edad"
                    value={calcularEdad(nacimientoSolicitante)}
                    label="Edad"
                    variant="standard"
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: 200 }}>
                  <TextField
                    id="estadoParticipante"
                    value={EstadoParticipante}
                    label="Estado del Participante"
                    variant="standard"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                {tipoPrestamo === "Hipotecario" && (
                  <FormControl sx={{ m: 1, width: 200 }}>
                    <TextField
                      id="teléfono"
                      value={movilSolicitante}
                      label="Teléfono"
                      variant="standard"
                      InputProps={{ readOnly: true }}
                    />
                  </FormControl>
                )}
              </Grid>
            </Stack>
          </Box>
          <Divider />
          {EstadoParticipante !== "JUBILADO" && (
            <Box>
              <Stack direction="row">
                <h3>II. INFORMACIÓN LABORAL (participantes activos)</h3>
              </Stack>

              <Stack direction="row">
                <Grid container>
                  <FormControl sx={{ m: 1, width: 350 }}>
                    <TextField
                      id="laboralDependencia"
                      value={dependenciaSolicitante}
                      label="Dependencia donde Trabaja"
                      variant="standard"
                      InputProps={{ readOnly: true }}
                    />
                  </FormControl>

                  <FormControl sx={{ m: 1, width: 200 }}>
                    <TextField
                      id="sueldoMensualsoli"
                      value={sueldoMensualSolicitante}
                      label="Sueldo Mensual"
                      variant="standard"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">L.</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                  </FormControl>
                  <FormControl sx={{ m: 1, width: 300 }}>
                    <TextField
                      id="otrosIngresossoli"
                      value={otrosIngresosSolicitante}
                      label="Otros Ingresos (detalle)"
                      variant="standard"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">L.</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                  </FormControl>
                  <FormControl sx={{ m: 1, width: 200 }}>
                    <TextField
                      id="sueldoNetosoli"
                      value={sueldoNetoSolicitante}
                      label="Sueldo Neto"
                      variant="standard"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">L.</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                  </FormControl>
                </Grid>
              </Stack>
            </Box>
          )}
          <Box marginTop={3}>
            <h3>IDENTIDAD DEL SOLICITANTE EN FORMATO PDF</h3>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Box
                style={{
                  padding: "50px",
                  width: "700px",
                  textAlign: "center",
                  borderColor: "gray",
                  borderRadius: 5,
                  borderWidth: 5,
                  borderStyle: "dashed",
                }}
              >
                <img
                  src={pdficon}
                  alt="Download PDF Icon"
                  style={{ width: 75, height: 77, color: "gray" }}
                />
                <br />
                <Button
                  variant="contained"
                  onClick={handleButtonIdentidad}
                  style={{ marginTop: "10px", backgroundColor: "#AD8401" }}
                >
                  Ver Archivo PDF
                </Button>
                <p>
                  Haz clic en el botón para visualizar la identidad del
                  solicitante en PDF
                </p>
                <Backdrop
                  open={openPdf}
                  onClick={handleCloseIdentidad}
                  style={{ zIndex: 1 }}
                >
                  <Dialog
                    open={openPdf}
                    onClose={handleCloseIdentidad}
                    maxWidth="md"
                    fullWidth
                  >
                    <DialogTitle textAlign={"center"}>
                      Identidad Del Solicitante
                    </DialogTitle>
                    <DialogContent>
                      {pdfUrl && (
                        <iframe
                          src={pdfUrl}
                          width="100%"
                          height="600px"
                        ></iframe>
                      )}
                    </DialogContent>
                  </Dialog>
                </Backdrop>
              </Box>
            </Box>
          </Box>

          <Box marginTop={5}>
            <h3>VOUCHERS DE PAGO DEL SOLICITANTE EN FORMATO PDF</h3>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Box
                style={{
                  padding: "50px",
                  width: "700px",
                  textAlign: "center",
                  borderColor: "gray",
                  borderRadius: 5,
                  borderWidth: 5,
                  borderStyle: "dashed",
                }}
              >
                <img
                  src={pdficon}
                  alt="Download PDF Icon"
                  style={{ width: 75, height: 77, color: "gray" }}
                />
                <br />
                <Button
                  variant="contained"
                  onClick={handleButtonVoucher}
                  style={{ marginTop: "10px", backgroundColor: "#AD8401" }}
                >
                  Ver Archivo PDF
                </Button>
                <p>Haz clic en el botón para visualizar el archivo PDF</p>
                <Backdrop
                  open={openPdfVoucher}
                  onClick={handleCloseVoucher}
                  style={{ zIndex: 1 }}
                >
                  <Dialog
                    open={openPdfVoucher}
                    onClose={handleCloseVoucher}
                    maxWidth="md"
                    fullWidth
                  >
                    <DialogTitle textAlign={"center"}>
                      Vouchers De Pago
                    </DialogTitle>
                    <DialogContent>
                      <iframe
                        src={pdfUrlVoucher}
                        width="100%"
                        height="450px"
                        style={{ border: "none" }}
                      />
                    </DialogContent>
                  </Dialog>
                </Backdrop>
              </Box>
            </Box>
          </Box>

          {tipoPrestamo === "Hipotecario" && (
            <Box marginTop={5}>
              <h3>
                AUTORIZACIÓN DE REFERENCIAS EN LA CENTRAL DE INFORMACIÓN
                CREDITICIA {isMobile ? "IMÁGENES" : "PDF"}
              </h3>
              <Box display="flex" alignItems="center" justifyContent="center">
                <Box
                  style={{
                    padding: "50px",
                    width: isMobile ? "300px" : "700px",
                    textAlign: "center",
                    borderColor: "gray",
                    borderRadius: 5,
                    borderWidth: 5,
                    borderStyle: "dashed",
                  }}
                >
                  <img
                    src={pdficon}
                    alt="Download PDF Icon"
                    style={{ width: 75, height: 77, color: "gray" }}
                  />
                  <br />
                  <Button
                    variant="contained"
                    onClick={handleButtonCentral}
                    style={{ marginTop: "10px", backgroundColor: "#AD8401" }}
                  >
                    Ver Archivo {isMobile ? "Imágenes" : "PDF"}
                  </Button>
                  <p>
                    Haz clic en el botón para visualizar el voucher de pago del
                    solicitante en {isMobile ? "imágenes" : "PDF"}
                  </p>
                  <Backdrop
                    open={openPdfCentral}
                    onClick={handleCloseCentral}
                    style={{ zIndex: 1 }}
                  >
                    <Dialog
                      open={openPdfCentral}
                      onClose={handleCloseCentral}
                      maxWidth="md"
                      fullWidth
                    >
                      <DialogTitle textAlign={"center"}>
                        Autorización de Referencias en la Central de Información
                        Crediticia
                      </DialogTitle>
                      <DialogContent>
                        {isMobile
                          ? // Mostrar imágenes si es móvil
                            pdfUrlCentral &&
                            pdfUrlCentral.map((base64Image, index) => (
                              <img
                                key={index}
                                src={`data:image/png;base64,${base64Image}`}
                                alt={`Central ${index + 1}`}
                                style={{ width: "100%", marginBottom: "10px" }}
                              />
                            ))
                          : // Mostrar PDF si es desktop
                            pdfUrlCentral && (
                              <iframe
                                src={pdfUrlCentral}
                                width="100%"
                                height="450px"
                                style={{ border: "none" }}
                              />
                            )}
                      </DialogContent>
                    </Dialog>
                  </Backdrop>
                </Box>
              </Box>
            </Box>
          )}

          <Divider style={{ marginTop: 5 }} />

          {tipoPrestamo === "Alivio de Deuda" && (
            <>
              <Box marginTop={3}>
                <h3>
                  CÁLCULO APROXIMADO DE PRESTACIONES LABORALES DEL SOLICITANTE
                  EN FORMATO PDF
                </h3>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Box
                    style={{
                      padding: "50px",
                      width: "700px",
                      textAlign: "center",
                      borderColor: "gray",
                      borderRadius: 5,
                      borderWidth: 5,
                      borderStyle: "dashed",
                    }}
                  >
                    <img
                      src={pdficon}
                      alt="Download PDF Icon"
                      style={{ width: 75, height: 77, color: "gray" }}
                    />
                    <br />
                    <Button
                      variant="contained"
                      onClick={handleButtonAproximado}
                      style={{ marginTop: "10px", backgroundColor: "#AD8401" }}
                    >
                      Ver Archivo PDF
                    </Button>
                    <p>
                      Haz clic en el botón para visualizar el cálculo de
                      prestaciones laborales del solicitante en PDF
                    </p>
                    <Backdrop
                      open={openPdfAproximado}
                      onClick={handleCloseAproximado}
                      style={{ zIndex: 1 }}
                    >
                      <Dialog
                        open={openPdfAproximado}
                        onClose={handleCloseAproximado}
                        maxWidth="md"
                        fullWidth
                      >
                        <DialogTitle textAlign={"center"}>
                          Identidad Del Solicitante
                        </DialogTitle>
                        <DialogContent>
                          {pdfUrlAproximado && (
                            <iframe
                              src={pdfUrlAproximado}
                              width="100%"
                              height="600px"
                            ></iframe>
                          )}
                        </DialogContent>
                      </Dialog>
                    </Backdrop>
                  </Box>
                </Box>
              </Box>
            </>
          )}

          {(tipoPrestamo === "Alivio de Deuda" ||
            tipoPrestamo === "Consolidacion de Deuda") && (
            <>
              <Box marginTop={3}>
                <h3>ESTADOS DE CUENTA DE LO ADEUDADO EN FORMATO PDF</h3>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Box
                    style={{
                      padding: "50px",
                      width: "700px",
                      textAlign: "center",
                      borderColor: "gray",
                      borderRadius: 5,
                      borderWidth: 5,
                      borderStyle: "dashed",
                    }}
                  >
                    <img
                      src={pdficon}
                      alt="Download PDF Icon"
                      style={{ width: 75, height: 77, color: "gray" }}
                    />
                    <br />
                    <Button
                      variant="contained"
                      onClick={handleButtonAdeudado}
                      style={{ marginTop: "10px", backgroundColor: "#AD8401" }}
                    >
                      Ver Archivo PDF
                    </Button>
                    <p>
                      Haz clic en el botón para visualizar los estados de cuenta
                      de las deudas en PDF
                    </p>
                    <Backdrop
                      open={openPdfAdeudado}
                      onClick={handleCloseAdeudado}
                      style={{ zIndex: 1 }}
                    >
                      <Dialog
                        open={openPdfAdeudado}
                        onClose={handleCloseAdeudado}
                        maxWidth="md"
                        fullWidth
                      >
                        <DialogTitle textAlign={"center"}>
                          Estados de cuenta de lo adeudado
                        </DialogTitle>
                        <DialogContent>
                          {pdfUrlAdeudado && (
                            <iframe
                              src={pdfUrlAdeudado}
                              width="100%"
                              height="600px"
                            ></iframe>
                          )}
                        </DialogContent>
                      </Dialog>
                    </Backdrop>
                  </Box>
                </Box>
              </Box>
            </>
          )}

          {(tipoPrestamo === "Con Aval" ||
            tipoPrestamo === "Consolidacion de Deuda" ||
            tipoPrestamo === "all") && (
            <>
              <AvalPrecargado
                identidad={identidadAval1}
                nombres={nombresAval1}
                apellidos={apellidosAval1}
                nacimiento={nacimientoAval1}
                profesion={profesionAval1}
                vivienda={tipoViviendaAval1}
                ave={avenidaAval1}
                barrio={barrioAval1}
                calle={calleAval1}
                casa={casaAval1}
                ciudad={ciudadAval1}
                departamento={departamentoAval1}
                estado={estadoCivilAval1}
                referenciadomicilio={referenciaDomicilioAval1}
                fijo={fijoAval1}
                movil={movilAval1}
                correo={correoAval1}
                dependencia={dependenciaAval1}
                ramo={ramoAval1}
                telefonolaboral={telefonoLaboralAval1}
                barriolaboral={barrioLaboralAval1}
                avenidalaboral={avenidaLaboralAval1}
                callelaboral={calleLaboralAval1}
                casalaboral={casaLaboralAval1}
                ciudadlaboral={ciudadLaboralAval1}
                departamentolaboral={departamentoLaboralAval1}
                sueldomensual={sueldoMensualAval1}
                otrosingresos={otrosIngresosAval1}
                sueldoneto={sueldoNetoAval1}
                puesto={puestoAval1}
                tiempolaborarA={tiempoLaborarAAval1}
                tiempolaborarM={tiempoLaborarMAval1}
                icono={pdficon}
                handleDescargar={handleButtonAval1}
                openAval1={openPdfAval1}
                closeAval1={handleCloseAval1}
                pdfUrlAval1={pdfUrlAval1}
              />

              <Box marginTop={5}>
                <h3>VOUCHERS DE PAGO DEL AVAL 1 EN FORMATO PDF</h3>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Box
                    style={{
                      padding: "50px",
                      width: "700px",
                      textAlign: "center",
                      borderColor: "gray",
                      borderRadius: 5,
                      borderWidth: 5,
                      borderStyle: "dashed",
                    }}
                  >
                    <img
                      src={pdficon}
                      alt="Download PDF Icon"
                      style={{ width: 75, height: 77, color: "gray" }}
                    />
                    <br />
                    <Button
                      variant="contained"
                      onClick={handleButtonVoucherAval1}
                      style={{ marginTop: "10px", backgroundColor: "#AD8401" }}
                    >
                      Ver Archivo PDF
                    </Button>
                    <p>Haz clic en el botón para visualizar el archivo PDF</p>
                    <Backdrop
                      open={openPdfVoucherAval1}
                      onClick={handleCloseVoucherAval1}
                      style={{ zIndex: 1 }}
                    >
                      <Dialog
                        open={openPdfVoucherAval1}
                        onClose={handleCloseVoucherAval1}
                        maxWidth="md"
                        fullWidth
                      >
                        <DialogTitle textAlign={"center"}>
                          Vouchers De Pago Del Aval 1
                        </DialogTitle>
                        <DialogContent>
                          <iframe
                            src={pdfUrlVoucherAval1}
                            width="100%"
                            height="450px"
                            style={{ border: "none" }}
                          />
                        </DialogContent>
                      </Dialog>
                    </Backdrop>
                  </Box>
                </Box>
              </Box>
              <Divider style={{ marginTop: 5 }} />
            </>
          )}

          {(tipoPrestamo === "Con Aval" ||
            tipoPrestamo === "Consolidacion de Deuda" ||
            tipoPrestamo === "all") && (
            <>
              {pdfUrlVoucherAval2 &&
              pdfUrlVoucherAval2.trim() !== "" &&
              pdfUrlAval2 &&
              pdfUrlAval2.trim() !== "" ? (
                <>
                  <Aval2Precargado
                    identidad={identidadAval2}
                    nombres={nombresAval2}
                    apellidos={apellidosAval2}
                    nacimiento={nacimientoAval2}
                    profesion={profesionAval2}
                    vivienda={tipoViviendaAval2}
                    ave={avenidaAval2}
                    barrio={barrioAval2}
                    calle={calleAval2}
                    casa={casaAval2}
                    ciudad={ciudadAval2}
                    departamento={departamentoAval2}
                    estado={estadoCivilAval2}
                    referenciadomicilio={referenciaDomicilioAval2}
                    fijo={fijoAval2}
                    movil={movilAval2}
                    correo={correoAval2}
                    dependencia={dependenciaAval2}
                    ramo={ramoAval2}
                    telefonolaboral={telefonoLaboralAval2}
                    barriolaboral={barrioLaboralAval2}
                    avenidalaboral={avenidaLaboralAval2}
                    callelaboral={calleLaboralAval2}
                    casalaboral={casaLaboralAval2}
                    ciudadlaboral={ciudadLaboralAval2}
                    departamentolaboral={departamentoLaboralAval2}
                    sueldomensual={sueldoMensualAval2}
                    otrosingresos={otrosIngresosAval2}
                    sueldoneto={sueldoNetoAval2}
                    puesto={puestoAval2}
                    tiempolaborarA={tiempoLaborarAAval2}
                    tiempolaborarM={tiempoLaborarMAval2}
                    icono={pdficon}
                    handleDescargar={handleButtonAval2}
                    openAval2={openPdfAval2}
                    closeAval2={handleCloseAval2}
                    pdfUrlAval2={pdfUrlAval2}
                  />

                  <Box marginTop={5}>
                    <h3>VOUCHERS DE PAGO DEL AVAL 2 EN FORMATO PDF</h3>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        style={{
                          padding: "50px",
                          width: "700px",
                          textAlign: "center",
                          borderColor: "gray",
                          borderRadius: 5,
                          borderWidth: 5,
                          borderStyle: "dashed",
                        }}
                      >
                        <img
                          src={pdficon}
                          alt="Download PDF Icon"
                          style={{ width: 75, height: 77, color: "gray" }}
                        />
                        <br />
                        <Button
                          variant="contained"
                          onClick={handleButtonVoucherAval2}
                          style={{
                            marginTop: "10px",
                            backgroundColor: "#AD8401",
                          }}
                        >
                          Ver Archivo PDF
                        </Button>
                        <p>
                          Haz clic en el botón para visualizar el archivo PDF
                        </p>
                        <Backdrop
                          open={openPdfVoucherAval2}
                          onClick={handleCloseVoucherAval2}
                          style={{ zIndex: 1 }}
                        >
                          <Dialog
                            open={openPdfVoucherAval2}
                            onClose={handleCloseVoucherAval2}
                            maxWidth="md"
                            fullWidth
                          >
                            <DialogTitle textAlign={"center"}>
                              Vouchers De Pago Del Aval 2
                            </DialogTitle>
                            <DialogContent>
                              <iframe
                                src={pdfUrlVoucherAval2}
                                width="100%"
                                height="450px"
                                style={{ border: "none" }}
                              />
                            </DialogContent>
                          </Dialog>
                        </Backdrop>
                      </Box>
                    </Box>
                  </Box>
                  <Divider style={{ marginTop: 5 }} />
                </>
              ) : (
                <h3>NOTA: EL SOLICITANTE NO AGREGÓ AVAL 2</h3>
              )}
            </>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "20vh", // Establece la altura de la caja para ocupar toda la pantalla verticalmente
            }}
          >
            <Grid item>
              {faseSolicitud === "Nuevo" && (
                <Button
                  endIcon={<TaskAltIcon style={{ fontSize: 40 }} />}
                  variant="contained"
                  color="success"
                  size="large"
                  onClick={handleOpen}
                >
                  <span>Aprobar</span>
                </Button>
              )}

              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Aprobar Solicitud de Preanálisis</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Si está seguro de aprobar la solicitud, añada la nota de
                    aprobación en el siguiente campo de texto.
                  </DialogContentText>
                  {tipoPrestamo === "Refinanciamiento" && (
                    <DialogContentText style={{ color: "red" }}>
                      <b>Observación:</b> Es un Refinanciamiento, por lo que no
                      se debe indicar que se adjuntan documentos.
                    </DialogContentText>
                  )}
                  <TextField
                    autoFocus
                    required
                    multiline
                    rows={5}
                    margin="dense"
                    id="notaAprobacion"
                    label="Nota De Aprobación"
                    fullWidth
                    variant="outlined"
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    endIcon={<HighlightOffIcon style={{ fontSize: 20 }} />}
                    onClick={handleClose}
                    size="large"
                    style={{ backgroundColor: "#AD8401" }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    endIcon={<TaskAltIcon style={{ fontSize: 20 }} />}
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={aprobarSolicitud}
                  >
                    Aprobar Solicitud
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog open={openSujeto} onClose={handleCloseSujeto}>
                <DialogTitle>
                  Aprobar Solicitud de Preanálisis Sujeta A Cambios
                </DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Si está seguro de aprobar la solicitud sujeta a cambios,
                    añada la nota de aprobación en el siguiente campo de texto.
                  </DialogContentText>
                  {tipoPrestamo === "Refinanciamiento" && (
                    <DialogContentText style={{ color: "red" }}>
                      <b>Observación:</b> Es un Refinanciamiento, por lo que no
                      se debe indicar que se adjuntan documentos.
                    </DialogContentText>
                  )}
                  <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="notaAprobacionSujeto"
                    label="Nota De Aprobación"
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={5}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    endIcon={<HighlightOffIcon style={{ fontSize: 20 }} />}
                    onClick={handleCloseSujeto}
                    size="large"
                    style={{ backgroundColor: "#AD8401" }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    endIcon={<TaskAltIcon style={{ fontSize: 20 }} />}
                    variant="contained"
                    color="warning"
                    size="large"
                    onClick={aprobarSolicitudSujeto}
                  >
                    Aprobar Solicitud
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openDialogEnviada}
                onClose={handleCloseDialogEnviada}
              >
                <DialogTitle>{"Aprobado"}</DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-slide-description"
                    align="justify"
                  >
                    La solicitud fue aprobada con éxito.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleCloseDialogEnviada}
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    color="success"
                  >
                    Aceptar
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openDialogRechazada}
                onClose={handleCloseDialogRechazada}
              >
                <DialogTitle>{"Rechazada"}</DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-slide-description"
                    align="justify"
                  >
                    La solicitud fue rechazada con éxito.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleCloseDialogRechazada}
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    color="success"
                  >
                    Aceptar
                  </Button>
                </DialogActions>
              </Dialog>

              {faseSolicitud === "Nuevo" && (
                <Button
                  endIcon={<TaskAltIcon style={{ fontSize: 40 }} />}
                  variant="contained"
                  color="warning"
                  size="large"
                  style={{ marginLeft: 10 }}
                  onClick={handleOpenSujeto}
                >
                  <span>Aprobar Sujeto A Cambio</span>
                </Button>
              )}

              {faseSolicitud === "Nuevo" && (
                <Button
                  endIcon={<HighlightOffIcon style={{ fontSize: 40 }} />}
                  variant="contained"
                  color="error"
                  size="large"
                  style={{ marginLeft: 10 }}
                  onClick={handleOpenRechazar}
                >
                  <span>Rechazar</span>
                </Button>
              )}

              <Dialog open={openRechazar} onClose={handleCloseRechazar}>
                <DialogTitle>Rechazar Solicitud de Preanálisis</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Si está seguro de rechazar la solicitud, añada la nota de
                    rechazo en el siguiente campo de texto.
                  </DialogContentText>
                  <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="notaRechazo"
                    label="Nota De Rechazo"
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={5}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    endIcon={<HighlightOffIcon style={{ fontSize: 20 }} />}
                    onClick={handleCloseRechazar}
                    size="large"
                    style={{ backgroundColor: "#AD8401" }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    endIcon={<TaskAltIcon style={{ fontSize: 20 }} />}
                    variant="contained"
                    color="error"
                    size="large"
                    onClick={rechazarSolicitud}
                  >
                    Rechazar Solicitud
                  </Button>
                </DialogActions>
              </Dialog>

              {/*<Button
                            endIcon={<LoopIcon style={{ fontSize: 40 }} />}
                            variant="contained"
                            color="info"
                            size="large"
                            onClick={handleOpenCorregirDocumentos}
                            style={{ marginLeft: 10 }}
                        >
                            <span>Corregir Documentos</span>
                        </Button>*/}

              <Dialog
                open={openCorregirDocumentos}
                onClose={handleCloseCorregirDocumentos}
              >
                <DialogTitle textAlign={"center"}>
                  Pedir Corrección de Documentos
                </DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Seleccione los archivos que deben corregirse:
                  </DialogContentText>

                  {/* Checkbox para selección de documentos */}
                  <div>
                    {getCheckboxOptions().map((option, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            value={option}
                            checked={selectedOptions.includes(option)}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label={option}
                      />
                    ))}
                  </div>

                  <DialogContentText style={{ marginTop: 15 }}>
                    Añada una nota sobre los documentos que el participante debe
                    corregir.
                  </DialogContentText>

                  {/* Campo de texto para la Nota de Corrección */}
                  <TextField
                    autoFocus
                    required
                    multiline
                    rows={3}
                    margin="dense"
                    id="notaAprobacion"
                    label="Nota De Corrección"
                    fullWidth
                    variant="outlined"
                    value={notaCorreccion}
                    onChange={handleNotaChange}
                  />

                  {/* Mostrar el mensaje de error si hay */}
                  {errorMessage && (
                    <Alert severity="error" style={{ marginTop: 10 }}>
                      {errorMessage}
                    </Alert>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    endIcon={<HighlightOffIcon style={{ fontSize: 20 }} />}
                    onClick={handleCloseCorregirDocumentos}
                    size="large"
                    style={{ backgroundColor: "#AD8401" }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    endIcon={<TaskAltIcon style={{ fontSize: 20 }} />}
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={handleEnviarCorreccion}
                  >
                    Enviar Corrección
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Box>
        </Container>
      </div>
    </>
  );
}

export default SolicitudCargaSimplificada;
